import {
  ChangeDetectorRef,
  Component,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  ViewChild,
  ElementRef,
  HostListener
} from '@angular/core';
import { WorkingHours } from 'src/app/models/persona/profile/workingHours';
import { ToastService } from 'src/app/services/toast.service';
import { AbstractControl, FormGroup, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { checkForValidationErrors } from 'src/app/utils/checkForValidationErrors';
import { HttpClient } from '@angular/common/http';
import { scrollToFirstInvalidControl } from 'src/app/utils/scrollToFirstInvalidControl';
import { ApcSectionAnchorsComponent } from '../apc-section-anchors/apc-section-anchors.component';
import { clearErrors } from 'src/app/utils/clearFormErrors';
import { UserPersonSharedService } from 'src/app/services/shared/user/person/sharedPerson.service';

@Component({
  selector: 'apc-multi-forms',
  templateUrl: './multi-forms.component.html',
  styleUrls: ['./multi-forms.component.scss'],
})
export class MultiFormsComponent {
  public data: WorkingHours[] = [];
  public form: UntypedFormGroup;
  @Input() forms: UntypedFormArray;
  public submitFailed = false;
  public allCollapsed = false;
  public canCollapse: boolean = false;
  private firstLoad: boolean = true;
  public subs:any;

  @Output() addTitleToCollapsableEvent = new EventEmitter<any>();
  @Output() calculateTotalHoursPercentageEvent = new EventEmitter<any>();
  @Output() fillFullTimeEvent = new EventEmitter<any>();
  @Output() toggleEdit = new EventEmitter<any>();
  @Output() saveSuccess = new EventEmitter<any>();
  @Output() readDisable = new EventEmitter<boolean>(false);
  @Output() openModalSplit = new EventEmitter<any>(false);
  @Output() openModalJoin = new EventEmitter<any>(false);
  @Output() subSectionToSplit = new EventEmitter<any>(false);
  @Output() updateForm = new EventEmitter<any>(false);
  @Output() checkExipDate = new EventEmitter<any>(false);
  @Input() public newEmptyForm: any;
  @Input() public newDataForm: any;
  @Input() public getData: Function;
  @Input() public createData: Function;
  @Input() public updateData: Function;
  @Input() public deleteData: Function;
  @Input() public user_id: string;
  @Input() public showHeaderIcon: boolean = true;
  @Input() public showRowIcon: boolean = true;

  @Input() formTemplate: TemplateRef<any>;
  @Input() header: string;
  @Input() pertinence: string;
  @Input() section: string;
  @Input() subsection: string;
  @Input() icon: string = '';
  @Input() hideHeader: boolean = false;

  @Input() openedId: string = null;
  @ViewChild(ApcSectionAnchorsComponent) sectionAnchors: ApcSectionAnchorsComponent;
  @ViewChild('toggle') toggle: ElementRef;
  @ViewChild('formElementsTrap') formElementsTrap: ElementRef;
  constructor(
    public http: HttpClient,
    private toastService: ToastService,
    public cdr: ChangeDetectorRef,
    private el: ElementRef,
    private userPersonSharedService: UserPersonSharedService
  ) {  }

  @HostListener('click', ['$event'])
  onTripleClickOpenEdit(e) {
    this.userPersonSharedService.isArchived$.subscribe(isArchived => {

      if (e.detail === 3 && !isArchived) {

        if (
          ((e.target.nodeName === 'INPUT' && !e.target.className.includes('autogenerated')) ||
            e.target.nodeName === 'svg' ||
            e.target.className.includes('toggle-track')) &&
          e.path.find((e) => e.classList.contains('apc-collapsable-row'))
        ) {
          e.target.removeAttribute('readonly');
          let collapsableRow = e.path.find((e) => e.classList.contains('apc-collapsable-row'));
          this.onEdit(
            this.forms.controls.find((el) => el.value.identifier === collapsableRow.id),
            true
          );
        }
      }
    });

  }

  @HostListener('document:keydown.enter', ['$event'])
  onKeydownHandler(e) {
    if (
      e.target.nodeName === 'INPUT' &&
      (e.path.find((e) => e.classList && e.classList.contains('apc-collapsable-row')) ||
        e.path.find((e) => e.classList && e.classList.toString().includes('apc-collapsable-row')))
    ) {
      let collapsableRow = e.path.find((e) => e.classList.contains('apc-collapsable-row'));
      let openedForm;
      if (collapsableRow.id !== 'null') {
        openedForm = this.forms.controls.find((el) => el.value.identifier === collapsableRow.id);
      } else {
        openedForm = this.forms.controls[this.forms.controls.length - 1];
      }
      if (openedForm.dirty) {
        this.saveForm(openedForm);
        e.target.blur();
      }
    }
  }

  async ngOnInit() {
    this.initData();
  }

  async getDataset() {
    var id = this.user_id;
    if (this.subsection.includes("kpi-")) {
      id = this.subsection.split("-")[1];
    }
    return this.getData(id);
  }

  async initData() {
    this.data = [];
    this.data = await this.getDataset();
    this.data.forEach((el) => {
      this.forms.push(this.newDataForm(el));
    });
    this.addTitleToCollapsable();
    this.toggleAll(true);
    if (this.openedId) {
      this.toggleElement(this.openedId, true);
    }
  }

  toggleAll(init: boolean = false) {
    this.allCollapsed = !this.allCollapsed;
    this.firstLoad = true;
    this.forms.controls.forEach((item: any) => {
      item.isCollapsed = this.allCollapsed;
    });
    if (!init) {
      setTimeout(() => {
        document
          .getElementById(this.forms.controls[0].value.identifier)
          .scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    }
  }

  setToggle() {
    this.toggleOthers();
    let canToggle = Object.values(this.forms.controls).filter((value: any) => value.isCollapsed === true).length === 3;
    if (!canToggle) {
      this.canCollapse = true;
    } else {
      this.allCollapsed = true;
      this.canCollapse = false;
    }
  }

  toggleOthers() {
    !this.allCollapsed &&
      this.forms.controls.forEach((item: any) => {
        if (item.value.identifier === this.openedId && this.firstLoad) {
          this.firstLoad = false;
          if (this.allCollapsed) {
            this.toggleElement(item.value.identifier, false);
          }
        } else if (item.value.identifier === this.openedId && !this.firstLoad) {
          if (this.allCollapsed) {
            item.isCollapsed = true;
          }
        }
      });
  }

  toggleElement(elemId: string, firstLoad: boolean) {
    var subsectionRoute = this.subsection;
    if (this.subsection.includes("kpi-")) {
      subsectionRoute = this.subsection.split("-")[0];
    }
    this.openedId = elemId;
    var fragments = window.location.pathname.split('/');
    var sectionIndex;

    fragments.forEach((f, i) => {
      if (f == this.section) {
        sectionIndex = i;
      }
    });
    // toggle urls between same multisection
    if (window.location.pathname.includes(subsectionRoute) && window.location.pathname.includes(this.section) && !firstLoad) {
      fragments[fragments.length - 1] = elemId;
    }
    // check if we were on another multisection on current page
    else if (fragments.length >= sectionIndex + 1 && !firstLoad) {
      fragments[sectionIndex + 1] = subsectionRoute;
      fragments[sectionIndex + 2] = elemId;
    } else if (!firstLoad && !sectionIndex) {
      sectionIndex=3;
      fragments[sectionIndex] = this.section
      fragments[sectionIndex + 1] = subsectionRoute;
      fragments[sectionIndex + 2] = elemId;
  /*     fragments.push(subsectionRoute);
      fragments.push(elemId); */
    }
    window.history.replaceState({}, '', fragments.join('/'));
    if (window.location.pathname.includes(subsectionRoute)) {
      this.forms.controls.forEach((item: any) => {
        if (item.value.identifier === elemId) {
          item.isCollapsed = !item.isCollapsed;
        } else {
          item.isCollapsed = true;
        }
      });
    }
  }

  addNewSection() {
    // going to check if we already have some epty form
    let emptyAlreadyExists = false;
    this.forms.controls.forEach((item) => {
      if (!item.value.identifier) {
        emptyAlreadyExists = true;
      }
    });
    // add new form only if we dont have any empty form initialized
    if (!emptyAlreadyExists) {
      const newForm = this.forms.insert(0, this.newEmptyForm());
      this.forms.controls.forEach((formControl: any) => {
        // if the form is new/being created, put it to edit mode
        if (!formControl.value.identifier) {
          formControl.editForm = true;
          this.newSectionBlanket();
        }
      });
    }
  }

  async saveForm(form: any) {
    try {
      if (form.valid || this.submitFailed) {
        let newItem = null;
        // if id exists it means we are editing
        if (form.value.identifier) {
          newItem = await this.updateData(this.user_id, form.value);
          form.patchValue(newItem);
          form.updateValueAndValidity();
          form.markAsPristine();
        }
        // creating new
        else {
          newItem = await this.createData(this.user_id, form.value);
          form.patchValue(newItem);
          form.updateValueAndValidity();
          form.markAsPristine();
        }
        form.editForm = false;
        this.addTitleToCollapsable();
        this.toastService.showSuccess('Operation success!');
        clearErrors(form);
        form.markAsUntouched();
        document.getElementById('blanket').classList.add('d-none');
        document.querySelector('.blanket-active').classList.remove('blanket-active');
        this.readDisable.emit(true);
        this.saveSuccess.emit(true);
        /* if(this.subsection === 'achievement'){
          this.updateAch.emit();
        } */
        this.updateForm.emit(newItem);
      } else {
        this.readDisable.emit(false);
        this.toastService.showError('Operation error!');
        form.markAsPristine();
        form.markAllAsTouched();
      }
    } catch (e) {
      clearErrors(form);
      this.submitFailed = true;
      this.toastService.showError('Operation error!');
      this.readDisable.emit(false);
      if (e.validationErrors?.length > 0) {
        form.markAsPristine();
        checkForValidationErrors(e, form);
        scrollToFirstInvalidControl(this.el);
      }
    }
  }
  async updateSubsection(id:string) {
    if(id){
      this.data = [];
      this.data = await this.getDataset();
      this.data.forEach((el) => {
        this.forms.push(this.newDataForm(el));
      });
      this.addTitleToCollapsable();
      this.forms.controls.forEach((item: any) => {
        if(item.value?.identifier != id)
          item.isCollapsed = true;
      });
      setTimeout(() => {
        if(document.getElementById(id))
          document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' });
      },400);
    }   
  }

  async cancelForm(item) {
    // if canceling form that exists (edit form), fetch old form data and replace that data with current data that we want to cancel
    if (item.value.identifier) {
      const index = this.forms.controls.findIndex((p) => p.value.identifier === item.value.identifier);
      this.data = await this.getDataset();
      let oldData = this.data.find((h) => h.identifier == item.value.identifier);
      let form = this.newDataForm(oldData);
      form.editForm = false;
      this.forms.controls[index] = form;
      this.addTitleToCollapsable();
    }
    // if canceling form that does not exist (new form), just remove it from the list
    else {
      this.forms.controls = this.forms.controls.filter((el) => el.value.identifier !== null);
    }
    // Emit undo EditMode Enabled
    this.onEdit(item, false);
    this.saveSuccess.emit(true);

  }

  async cloneForm(item) {
    this.data = await this.getDataset();
    let hoursToClone = this.data.find((h) => h.identifier == item.value.identifier);
    // copying object, removing references to the object we copied from
    let clonedHours = JSON.parse(JSON.stringify(hoursToClone));
    // puting id to null beacuse it is a new form
    clonedHours.identifier = null;
    // pushing to the forms list
    this.forms.push(this.newDataForm(clonedHours));
    this.addTitleToCollapsable();
    // opening new form for editing mode
    this.forms.controls.forEach((item: any) => {
      // if the form is new/being created, put it to edit mode
      if (!item.value.identifier) {
        item.editForm = true;
        this.newSectionBlanket();
      }
    });
  }

  async delete(subsectionIdentifier: string) {
    await this.deleteData(this.user_id, subsectionIdentifier);
    this.forms.controls = this.forms.controls.filter((el) => el.value.identifier !== subsectionIdentifier);
    this.resetIds();
    this.toastService.showSuccess('Operation success!');
    this.saveSuccess.emit(true);
  }

  resetIds() {
    this.forms.controls.forEach((el, index) => {
      if (document.getElementById(el.value.identifier)) {
        let row: any = document.getElementById(el.value.identifier);
        row.getElementsByTagName("div")[0].id = this.section+"-"+this.subsection + '-row-' + index;
      }
    })
  }

  addTitleToCollapsable() {
    this.addTitleToCollapsableEvent.emit(this.forms);
  }

  calculateTotalHoursPercentage(form: UntypedFormGroup) {
    this.calculateTotalHoursPercentageEvent.emit();
  }

  fillFullTime(item) {
    this.fillFullTimeEvent.emit(item);
    item.markAsDirty();
  }

  toggleExpandedClass(toggle) {
    let toggleEl: HTMLDivElement = <HTMLDivElement>this.toggle.nativeElement;
    if (toggle) {
      toggleEl.classList.remove('toggle-shrinked');
      toggleEl.classList.add('toggle-expanded');
    } else {
      if (this.allCollapsed) {
        toggleEl.classList.remove('toggle-expanded');
        toggleEl.classList.add('toggle-shrinked');
      }
    }
  }

  onEdit(item, event) {
    if(event) this.readDisable.emit(false);
    else this.readDisable.emit(true);
    this.manageBlanket(item.value.identifier, event);
    item.editForm = event;
  }

  public editModeArray = [];
  manageBlanket(itemId: string, isEdit: boolean) {
    var rowId;
    if (itemId) {
      rowId = this.forms.controls.findIndex((control) => control.value.identifier == itemId);
    } else {
      rowId = this.forms.controls.length - 1;
    }
    if (isEdit === false) {
      this.editModeArray = this.editModeArray.filter((obj) => obj !== isEdit);
      document.getElementById('blanket')?.classList.add('d-none');
      document.getElementById(this.section+"-"+this.subsection + `-row-${rowId}`)?.classList.remove('blanket-active');
    } else if (isEdit === true) {
      this.editModeArray.push(itemId);
      document.getElementById('blanket')?.classList.remove('d-none');
      document.getElementById(this.section+"-"+this.subsection + `-row-${rowId}`)?.classList.add('blanket-active');
    }
  }

  newSectionBlanket() {
    setTimeout(() => {
      document.getElementById('blanket').classList.remove('d-none');
      let newElementId;
/*       this.subsection === "company" ? newElementId = this.section+"-"+this.subsection + `-row-0` : newElementId = this.section+"-"+this.subsection + `-row-${this.forms.controls.length - 1}`;
 */     
      newElementId = this.section+"-"+this.subsection + `-row-0`
      let i = 2;
      while(!document.getElementById(newElementId)) {
        newElementId = this.section+"-"+this.subsection + `-row-${this.forms.controls.length - i}`;
        i++;
      }
      document.getElementById(newElementId).classList.add('blanket-active');
      document.getElementById(newElementId).scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' });
    }, 400);
  }

  joinForm(item:any){
    this.subSectionToSplit.emit(item);
    this.openModalJoin.emit();   
    this.subs= item
  }

  splitForm(item:any){
    this.subSectionToSplit.emit(item);
    this.openModalSplit.emit();  
    this.subs= item;
  }

  changeValue(value) {
    this.readDisable.emit(value);
  }

  checkExpirationDate(formToCheck:any){
    console.log("checkExpirationDate");
    this.checkExipDate.emit(formToCheck);
  }
}
